import React, {useEffect, useRef} from "react"
import { connect } from "react-redux"
import classNames from "classnames"
import moment from "moment";
import { Picky } from "react-picky";

import {
  getPlaceholderForMenuFieldConfiguration,
  getValueObjectBy,
  hasBeenFilled
} from "../../../../helpers/dynamicFormHelper";
import {ConfigurationsType, MenuSearchFieldType} from "../../../../types/configurations";
import {ShapeType} from "../../../../types/shape";
import {
  isMultiSelectionFieldFromConfigurations
} from "../../../../helpers/configurationHelper";
import { FormikProps } from "formik/dist/types";
import translations from "../../../../translations";
import {AppParametersType} from "../../../../types/app";

interface PropsType {
  configurations: ConfigurationsType,
  scopeConfigurationFields: string,
  fieldConfigurations: MenuSearchFieldType,
  selectedArea: ShapeType,
  forceDisabled: boolean,
  disabled: boolean,
  changeFilterDispatchActionHandler: any,
  formProps: FormikProps<any>,
  language:string,
  bypassAll: boolean,
  isProductionField: boolean,
  appParameters: AppParametersType
}

const MenuSearchField = (props: PropsType) => {
  const {
    configurations,
    scopeConfigurationFields,
    fieldConfigurations,
    disabled,
    forceDisabled,
    selectedArea,
    changeFilterDispatchActionHandler,
    formProps: {
      values
    },
    language,
    bypassAll,
    isProductionField = false,
    appParameters
  } = props;

  const {
    name: fieldName,
  } = fieldConfigurations;

  const menuRef:any = useRef(null);

  const {
    possibleValues,
    value,
  } = getValueObjectBy(configurations, appParameters, scopeConfigurationFields, fieldName, values, selectedArea, isProductionField);

  useEffect(() => {
    // value has changed from values, saving filter value
    let savedValue: string = "";
    if (values[fieldName]) {
      if (Array.isArray(values[fieldName])) {
        savedValue = values[fieldName].join();
      } else {
        savedValue = values[fieldName];
      }
    }
    let currentValue: string = "";
    if (value) {
      if (Array.isArray(value)) {
        currentValue = value.join();
      } else {
        currentValue = value;
      }
    }
    if (currentValue !== savedValue) {
      changeFilterDispatchActionHandler(fieldName, value);
    }
  }, [value]);

  const isInputDisabled = forceDisabled || (disabled && hasBeenFilled(value)) || possibleValues.length === 1;
  const isClearable = hasBeenFilled(value) && !isInputDisabled;
  const isMultipleSelectionAvailable = isMultiSelectionFieldFromConfigurations(configurations, appParameters, scopeConfigurationFields, fieldName, values, selectedArea);
  let isSelectAllIncluded = false;

  let valueOption;
  let options = possibleValues.map((v) => getSelectOptionBy(fieldName, v));

  if(bypassAll){
    options = options.filter(option => option.value.toLowerCase() !== 'all');
  }

  if (isMultipleSelectionAvailable) {
    isSelectAllIncluded = !!options.find((option) => option.value === "All");
    if (isSelectAllIncluded) {
      options = options.filter((option) => option.value !== "All");
    }
    valueOption = (value && value.map((v) => getSelectOptionBy(fieldName, v))) || [];
  } else {
    valueOption = (value && getSelectOptionBy(fieldName, value)) || null;
  }

  return (
    <div ref={menuRef}>
      <Picky
        id={`picky-${fieldName}`}
        className={classNames({
          "single-value-selection": isInputDisabled
        })}
        numberDisplayed={1}
        options={options}
        valueKey="value"
        labelKey="label"
        keepOpen={false}
        multiple={isMultipleSelectionAvailable}
        includeSelectAll={isSelectAllIncluded}
        placeholder={getPlaceholderForMenuFieldConfiguration(fieldConfigurations, language)}
        value={valueOption}
        onChange={(input) => {
          const newOptionValuesSelected = isMultipleSelectionAvailable
            ? (input as Array<any>).map((m) => m["value"])
            : input["value"];

          changeFilterDispatchActionHandler(fieldName, newOptionValuesSelected);
        }}
        onOpen={() => {
          if (menuRef) {
            menuRef.current.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
          }
        }}
        dropdownHeight={140}
        disabled={isInputDisabled}
        allSelectedPlaceholder={translations('allSelected',language)}
        manySelectedPlaceholder={translations('manySelected',language)}
        selectAllText={translations('selectAllSearchFilters',language)}
      />
      <div
        className={classNames("picky-clear-icon-container", {
          "d-none": !isClearable
        })}
        role="button"
        aria-hidden="true"
        onClick={() => {
          changeFilterDispatchActionHandler(fieldName, null);
        }}
      >
        <svg><use xlinkHref="#close-icon" /></svg>
      </div>
    </div>
  );
};

const getSelectOptionBy = (fieldName, value) => {
  let label = value;
  if (["masterImage"].includes(fieldName)) {
    label = moment.utc(value).format("YYYY/MM/DD HH:mm:ss");
  }

  return {
    value,
    label
  };
};

const mapStateToProps = (state) => ({
  language: state.application.appParameters.language,
  appParameters: state.application.appParameters,
});

export default connect(mapStateToProps)(MenuSearchField)
